export default __webpack_public_path__ + "static/media/Kick2.e1a2f58d.mp3";